import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Context } from "../../../shared/Context/Context";
import { useNavigate } from "react-router-dom";
import { API } from "../../../shared/Api/Api";
import "./Login.scss";
import { Box, Flex, FormLabel, Heading, Input, Text } from "@chakra-ui/react";
import Loading from "../../../components/Loading/Loading";
import LoginButton from "../../../components/LoginButton/LoginButton";
import { Fade } from "react-awesome-reveal";
import { FormattedMessage } from "react-intl";

const Login = () => {
  const { register, handleSubmit } = useForm();
  const { setJwt, setIsRegistered, setIsAdmin, tabletOrLess } =
    useContext(Context);
  const [errorLogin, setErrorLogin] = useState();
  const [loading, setLoading] = useState();
  let navigate = useNavigate();

  const logIn = (formData) => {
    setLoading(true);

    API.post("user/login", formData)
      .then((res) => {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.userDB));
        setIsRegistered(true);
        setJwt(res.data.token);
        if (res.data.userDB.rol === "admin") {
          setIsAdmin(true);
        }
        navigate("/");
        setLoading(false);
      })
      .catch((error) => {
        setErrorLogin(error.response.data);
        setLoading(false);
      });
  };

  return (
    <Flex
      h={tabletOrLess ? "100vh" : "87vh"}
      w="100%"
      justify="center"
      align="center"
      backgroundColor="#ff6e6c"
    >
      <form className="form" autoComplete="off" onSubmit={handleSubmit(logIn)}>
        <Heading>
          <Fade triggerOnce cascade damping={0.05}>
            <FormattedMessage
              id="app.login.heading"
            />
          </Fade>
        </Heading>
        <Box h="13px">
          {errorLogin && (
            <Text fontWeight="bold" color="#ff6e6c">
              {errorLogin}
            </Text>
          )}
        </Box>
        <Flex
          justify="center"
          align="flex-start"
          flexDir="column"
          mb="30px"
          w={!tabletOrLess && "50%"}
        >
          <FormLabel fontWeight="bold">
            <FormattedMessage
              id="app.login.userName"
            />
          </FormLabel>
          <Input
            border="none"
            backgroundColor="#FFFFFFF"
            p="8px"
            fontWeight="bold"
            mt="15px"
            borderBottom="1px solid black"
            w={!tabletOrLess && "100%"}
            fontSize={!tabletOrLess && "larger"}
            _focus={{ outline: "none" }}
            placeholder="Username"
            id="userName"
            {...register("userName", { required: true })}
          />
        </Flex>
        <Flex
          justify="center"
          align="flex-start"
          flexDir="column"
          m="0px !important"
          w={!tabletOrLess && "50%"}
        >
          <FormLabel fontWeight="bold">
            <FormattedMessage
              id="app.login.password"
            />
          </FormLabel>
          <Input
            border="none"
            backgroundColor="#FFFFFFF"
            mt="15px"
            p="8px"
            fontWeight="bold"
            borderBottom="1px solid black"
            w={!tabletOrLess && "100%"}
            fontSize={!tabletOrLess && "larger"}
            _focus={{ outline: "none" }}
            placeholder="Contraseña"
            id="password"
            type="password"
            {...register("password", { required: true })}
          ></Input>
        </Flex>
        <Fade>
          <Box h="30px">
            {loading ? <Loading mini /> : <LoginButton texto="Login" />}
          </Box>
        </Fade>
      </form>
    </Flex>
  );
};

export default Login;
